import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a060bb2c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a060bb2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a060bb2c')) {
      api.createRecord('a060bb2c', component.options)
    } else {
      api.reload('a060bb2c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a060bb2c&scoped=true&", function () {
      api.rerender('a060bb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b8DZu5Fk4WE6/JS/comp/Accordion.vue"
export default component.exports